export class SetFocus{
    public to(fieldName: string, isFocusSet:boolean): boolean {
       try{
            if (!isFocusSet)
                document.getElementById(fieldName).focus();
            return true;
        } catch (e) {
            return false;
        }
    }
}


// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/shared/setFocus.ts